/**
 * Reusable Card Component
 */

import { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  title?: string
}

export function Card({ children, className = '', title }: CardProps) {
  return (
    <div className={`surface rounded-lg shadow-lg ${className}`}>
      {title && (
        <div className="px-3 sm:px-6 py-3 sm:py-4 border-b border-gray-200 dark:border-industrial-border">
          <h2 className="text-base sm:text-xl font-semibold text-primary">{title}</h2>
        </div>
      )}
      <div className="p-3 sm:p-6">{children}</div>
    </div>
  )
}
